import { ReportStatus } from '../types';

export const getStatusColor = (status: ReportStatus): string => {
  switch (status) {
    case ReportStatus.Completed:
      return 'green';
    case ReportStatus.CompletedWithRevisions:
      return 'orange';
    case ReportStatus.MissingInformation:
      return 'red';
    case ReportStatus.Processing:
      return 'blue';
    case ReportStatus.Enqueued:
      return 'blue';
    case ReportStatus.Error:
      return 'red';
    default:
      return 'inherit';
  }
};
